import { render, staticRenderFns } from "./patentServices.vue?vue&type=template&id=31f1a4a2&scoped=true"
import script from "./patentServices.vue?vue&type=script&lang=js"
export * from "./patentServices.vue?vue&type=script&lang=js"
import style0 from "./patentServices.vue?vue&type=style&index=0&id=31f1a4a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f1a4a2",
  null
  
)

export default component.exports